module.exports = __webpack_public_path__ + "img/region-global.06c812c7.png";